// extracted by mini-css-extract-plugin
export default {"base":"WidgetHeaderTicker_base__hiUzD","ticker-image-wrapper":"WidgetHeaderTicker_ticker-image-wrapper__8gSDK","tooltip-icon":"WidgetHeaderTicker_tooltip-icon__crA2E"};